<div class="row mb-3" [formGroup]="timeRecordingAddNewEntryForm">
    <!-- MOBILE LAYOUT -->
    <div *ngIf="isMobile$ | async; else desktopTemplate">
        <div class="row">
            <div class="col-12">
                <!-- TYPE OF WORK -->
                <label class="col-form-label">
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_TYPE_OF_WORK"></span>
                    <span class="px-1">/</span>
                    <span translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_ACTIVITY"></span>
                </label>
            </div>
            <div class="col-6">
                <pace-core-dropdown
                    [(model)]="model.typeOfWorkModel"
                    (valueChange)="onTypeOfWorkChange()"
                    id="newEntryTypeOfWorkDropDown"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                >
                </pace-core-dropdown>
            </div>
            <div class="col-6" *ngIf="displayActivities">
                <pace-core-dropdown
                    *ngIf="displayActivities && displayActivityDropdown"
                    [(model)]="model.activitiesModel"
                    class="inline-dropdown"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                >
                </pace-core-dropdown>
            </div>
        </div>
        <!-- START DATE and TIME -->
        <div class="row">
            <div class="col-12">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_START"> </label>
            </div>
            <div class="col-7">
                <pace-core-date-input
                    [(model)]="model.startDateModel"
                    (valueChange)="onStartDateTimeChange()"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                >
                </pace-core-date-input>
            </div>
            <div class="col-5">
                <pace-core-time-input
                    [(model)]="model.startTimeModel"
                    (valueChange)="onStartDateTimeChange()"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                >
                </pace-core-time-input>
            </div>
        </div>
        <!-- End DATE and TIME -->
        <div class="row">
            <div class="col-12 mt-3">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END"> </label>
            </div>
            <div class="col-7">
                <pace-core-date-input
                    [(model)]="model.endDateModel"
                    (valueChange)="onEndDateTimeChange()"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                >
                </pace-core-date-input>
            </div>
            <div class="col-5">
                <pace-core-time-input
                    [(model)]="model.endTimeModel"
                    (valueChange)="onEndDateTimeChange()"
                    [parentForm]="timeRecordingAddNewEntryFormChildren"
                    [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                >
                </pace-core-time-input>
            </div>
        </div>
        <!-- Duration -->
        <div class="row mt-3">
            <div class="col-6">
                <label class="col-form-label m-auto" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_DURATION">
                </label>
            </div>
            <div class="col-6">
                <label class="col-form-label fw-normal" *ngIf="model.getFormattedDuration()">
                    {{ model.getFormattedDuration() }}
                </label>
            </div>
        </div>
        <!-- BILLABLE -->
        <div class="row mt-3">
            <div class="col-4">
                <label class="col-form-label" translate="CONFIRMATION_TIMERECORDING_CONFIRM_DESC_BILLABLE"> </label>
            </div>
            <div class="col" *ngIf="displayBillableDropdown">
                <pace-core-dropdown [(model)]="model.billableModel" [parentForm]="timeRecordingAddNewEntryFormChildren">
                </pace-core-dropdown>
            </div>
        </div>

        <!-- VALIDATION MESSAGES for a specific entry-->
        <div class="row mt-3" *ngIf="falsyValidationResults.length > 0">
            <div class="col-12">
                <div class="alert alert-danger" role="alert">
                    <p *ngFor="let validationEntry of falsyValidationResults">
                        {{ validationEntry.validationErrorMessage }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <!-- END OF MOBILE LAYOUT-->

    <!-- DESKTOP LAYOUT -->
    <ng-template #desktopTemplate>
        <div class="row">
            <div class="col-1 limited-col-width pe-0"></div>

            <!-- Left hand section: Start / End and Type of Work -->
            <div class="col-6">
                <!-- START DATE and TIME -->
                <div class="row gap-2">
                    <div class="col-5 p-0">
                        <pace-core-date-input
                            [(model)]="model.startDateModel"
                            (valueChange)="onStartDateTimeChange()"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTDATE' | translate"
                        >
                        </pace-core-date-input>
                    </div>
                    <div class="col-3 p-0">
                        <pace-core-time-input
                            [(model)]="model.startTimeModel"
                            (valueChange)="onStartDateTimeChange()"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_STARTTIME' | translate"
                        >
                        </pace-core-time-input>
                    </div>
                    <!-- TYPE OF WORK -->
                    <div class="col p-0">
                        <pace-core-dropdown
                            [(model)]="model.typeOfWorkModel"
                            (valueChange)="onTypeOfWorkChange()"
                            id="newEntryTypeOfWorkDropDown"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                        >
                        </pace-core-dropdown>
                    </div>
                </div>

                <!-- End DATE and TIME -->
                <div class="row mt-1 gap-2">
                    <div class="col-5 p-0">
                        <pace-core-date-input
                            [(model)]="model.endDateModel"
                            (valueChange)="onEndDateTimeChange()"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_DATE' | translate"
                        >
                        </pace-core-date-input>
                    </div>
                    <div class="col-3 p-0">
                        <pace-core-time-input
                            [(model)]="model.endTimeModel"
                            (valueChange)="onEndDateTimeChange()"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                            [ariaLabel]="'CONFIRMATION_TIMERECORDING_CONFIRM_DESC_END_TIME' | translate"
                        >
                        </pace-core-time-input>
                    </div>
                </div>
            </div>

            <!-- Right hand section: -->
            <div class="col-5">
                <div class="row">
                    <!-- ACTIVITY P58-->
                    <div class="col-4" *ngIf="displayActivities">
                        <pace-core-dropdown
                            *ngIf="displayActivities && displayActivityDropdown"
                            [(model)]="model.activitiesModel"
                            class="inline-dropdown"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                        >
                        </pace-core-dropdown>
                    </div>

                    <!-- DURATION -->
                    <div class="col-2 px-0 text-center">
                        <label class="col-form-label fw-normal" *ngIf="model.getFormattedDuration()">
                            {{ model.getFormattedDuration() }}
                        </label>
                    </div>

                    <!-- BILLABLE -->
                    <div class="col-4" *ngIf="displayBillableDropdown">
                        <pace-core-dropdown
                            [(model)]="model.billableModel"
                            [parentForm]="timeRecordingAddNewEntryFormChildren"
                        >
                        </pace-core-dropdown>
                    </div>
                </div>
            </div>
        </div>
        <!-- VALIDATION MESSAGES for a specific entry-->
        <div class="row mt-3" *ngIf="falsyValidationResults.length > 0">
            <div class="col-1 limited-col-width px-0"></div>
            <div class="col-11 flex-lg-grow-1 ps-0">
                <div class="alert alert-danger" role="alert">
                    <p *ngFor="let validationEntry of falsyValidationResults">
                        {{ validationEntry.validationErrorMessage }}
                    </p>
                </div>
            </div>
        </div>
    </ng-template>
    <!-- END OF DESKTOP LAYOUT-->
</div>

<div class="row mb-3">
    <div class="col-12 d-flex align-items-center justify-content-md-end justify-content-between">
        <button
            class="btn btn-secondary"
            (click)="discard()"
            translate="CONFIRMATION_TIMERECORDING_DISCARD_ENTRY_LABEL"
        ></button>
        <button
            class="btn btn-primary ms-1"
            [disabled]="timeRecordingAddNewEntryForm.invalid"
            (click)="save()"
            translate="CONFIRMATION_TIMERECORDING_SAVE_ENTRY_LABEL"
        ></button>
    </div>
</div>
<hr class="separator d-block d-lg-none" />
